import React, { Component, Fragment } from 'react'
// CSS
import '../App.css'
import AdminFormUser from './AdminFormUser'
import Header from './Header'
import { Redirect } from 'react-router-dom'

// Firebase
import base from '../base'

class Users extends Component {
  state = {
    pseudo: this.props.match.params.pseudo,
    users: [],
    admin:{},
    chef: '',
    redirect:false
    }

  componentDidMount(){
    if(this.props.location.state !== undefined)
    {
      this.setState({
        chef: this.props.location.state.chef
      })
    } 
    //reference ds firebase
    this.ref = base.syncState(`/user/${this.state.pseudo}/admin`,{
      context: this,
      state: 'admin'
    })
    this.ref = base.syncState(`/user`,{
      context: this,
      state: 'users'
    })
  }
  
  componentWillUnmount () {
    //fermer la reference ds firebase
    //la connexion est terminée entre notre state et firebase
    base.removeBinding(this.ref)
  }

  majUser = (key, newUser) => {
    const users = { ...this.state.users }
      users[key] = newUser
      this.setState({ users })
  }

  supprimerUser = key => {
    const users = { ...this.state.users }
    if((users[key].chef !== this.state.chef && users[key].name !== this.state.pseudo))
    {
      users[key] = null
      this.setState({ users })
    }
    else if((users[key].chef === this.state.chef && users[key].name !== this.state.pseudo))
    {
      users[key] = null
      this.setState({ users })
    }
    else{

    }
  }


  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }

renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect push to={
        `/adminCreationContent/${this.state.pseudo}`} />
      }
    }
    render () {
      if(this.props.location.state === undefined){
        return(
          <Fragment>
          <div className=" notFound">
          <h2>Veuillez retourner a la page de connexion</h2>
          {this.renderRedirect()}
          <button onClick={this.setRedirect}>Retour</button>
          </div> 
          </Fragment>
        )
        }
      return (
  
        <Fragment>
        <Header pseudo={this.state.pseudo}></Header>
  
        <div className='cards'>
  
        {
          Object.keys( this.state.users )
          .map(key => <AdminFormUser
          key={key}
          id={key} 
          majUser={this.majUser}
          supprimerUser={this.supprimerUser}
          pseudo={this.state.pseudo}
          users={this.state.users}/>)
  
        }
        </div>
        <div className="back">
          {this.renderRedirect()}
          <button onClick={this.setRedirect}>Retour</button>
        </div> 
        </Fragment>
  
      )
    }
  }
  
  export default Users